module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0042.2d1748bd.jpg";